module.exports = __webpack_public_path__ + "static/media/Fairways-West-HOA-Bylaws.44930f92.pdf";